
export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-map-pin-line',
      title: '沖縄地域密着型SEO',
      description: '「沖縄 カフェ 新規オープン」「沖縄 ネイルサロン LP」など地域特化キーワードで上位表示を実現'
    },
    {
      icon: 'ri-eye-line',
      title: '現地視点でのデザイン',
      description: '沖縄の文化や市場ニーズを深く理解した現地デザイナーが、地域に愛されるサイトを制作'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'モバイル完全対応',
      description: '沖縄の観光客や地元客の多くがスマートフォンでアクセス。完全レスポンシブ対応で機会損失を防止'
    },
    {
      icon: 'ri-speed-line',
      title: '高速表示最適化',
      description: 'ページ読み込み速度を最適化し、SEO効果とユーザー体験の両方を向上させます'
    },
    {
      icon: 'ri-customer-service-line',
      title: '地域密着サポート',
      description: '沖縄県内での対面打ち合わせ可能。アフターサポートも充実で安心してお任せいただけます'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'コンバージョン重視',
      description: '単なる見た目の良さではなく、実際の集客・売上向上につながるサイト設計を重視'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            選ばれる<strong>6つの理由</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            私たちは沖縄の起業家や新商品開発者、ポップアップイベント主催者、新規カフェ・店舗の皆様に特化したLP制作およびホームページ制作を行っています。強みは地元の視点を活かし、現地のニーズに沿ったデザインとコンテンツを提供していることです。独自の地域密着SEO戦略を駆使し、キーワードで検索上位表示を目指します。これにより、沖縄の市場で確実にビジネスを成功に導くLP・ホームページを作成します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center group">
              <div className="w-20 h-20 bg-gradient-to-r from-blue-600 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-4">{feature.title}</h4>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
